{
  "title": "分享您的位置可以加快報到流程",
  "body": "很抱歉，若無法存取您的位置，我們將無法完成您的報到。請授予位置存取權限以繼續。我們僅將您的位置用於倉庫報到，不會儲存或與第三方分享您的位置資訊。",
  "shareLocation": "分享我的位置"
}
